import { useContext, useEffect } from 'react'
import { getTokenAndUid } from '../../lib/utils'
import { AccountContext } from '../../providers/accountProvider'

const FreshChat = () => {
  const { user } = useContext(AccountContext)
  useEffect(() => {
    if (window.fcWidget) {
      window.fcWidget.init({
        token: '77c39ffd-cd0c-4e39-82c0-4f9681053b4e',
        host: 'https://wchat.in.freshchat.com',
        tags: user?.location === 'US' ? ['usa-writers'] : ['writers'],
      })
      window.fcWidget.user.get(function(resp) {
        const status = resp && resp.status
        if (getTokenAndUid().uid) {
          const uid = getTokenAndUid().uid
          const firstName = window.localStorage.getItem('name') || ''
          const phone = window.localStorage.getItem('phone') || ''
          window.fcWidget.setExternalId(uid)
          window.fcWidget.user.setProperties({
            firstName,
            phone,
            email: user?.email || '',
            phoneCountry: user?.location || 'IN'
          })
        }
      })
    }
  }, [user])
  return null
}

export default FreshChat
